import { adj, f, m, type Pool } from './poolTypes.ts';

export const BR_POOL: Pool = {
  key: 'br',
  animals: [
    ...['tucano', 'jacare', 'boto', 'tamandua', 'lobo', 'tigre', 'leao', 'gato', 'tatu', 'cavalo', 'galo', 'coelho',
      'elefante', 'avestruz', 'pavao', 'touro', 'urso', 'carneiro', 'sagui', 'jabuti', 'pirarucu', 'tubarao', 'golfinho',
      'papagaio', 'periquito', 'siri', 'grilo', 'panda', 'lince', 'puma', 'cisne', 'corvo', 'falcao', 'gaviao', 'pinguim',
      'camelo', 'peixe', 'polvo', 'quati', 'lagarto', 'camaleao', 'pelicano', 'flamingo', 'sapo'].map(m),
    ...['onca', 'arara', 'capivara', 'coruja', 'garca', 'aguia', 'borboleta', 'lontra', 'tartaruga', 'formiga',
      'abelha', 'cobra', 'leoa', 'loba', 'gata', 'raposa', 'zebra', 'girafa', 'preguica', 'ema', 'foca', 'iguana', 'arraia',
      'lagosta', 'joaninha', 'cotia', 'paca', 'sucuri', 'jaguatirica'].map(f),
  ],
  petForms: [
    ...['lobinho', 'lobao', 'capivarao', 'tigrao', 'gatinho', 'gatao', 'leaozinho', 'ursinho', 'coelhinho', 'tatuzinho',
      'sapinho', 'passarinho', 'peixinho', 'patinho', 'jacarezinho', 'tucaninho'].map(m),
    ...['oncinha', 'gatinha', 'corujinha', 'raposinha', 'cobrinha', 'formiguinha', 'abelhinha', 'ararinha'].map(f),
  ],
  adjectives: [
    'sortudo/sortuda', 'esperto/esperta', 'brabo/braba', 'bravo/brava', 'feliz', 'veloz', 'ligeiro/ligeira',
    'malandro/malandra', 'marrento/marrenta', 'top', 'sinistro/sinistra', 'maluco/maluca', 'doido/doida', 'chique',
    'estiloso/estilosa', 'tranquilo/tranquila', 'zen', 'lindo/linda', 'fofo/fofa', 'doce', 'forte', 'nobre',
    'sabio/sabia', 'sagaz', 'astuto/astuta', 'audaz', 'calmo/calma', 'alegre', 'risonho/risonha', 'faceiro/faceira',
    'arretado/arretada', 'massa', 'dahora', 'irado/irada', 'manso/mansa', 'valente', 'guerreiro/guerreira',
    'invicto/invicta', 'craque', 'fera', 'lendario/lendaria', 'epico/epica', 'magico/magica', 'dourado/dourada', 'azul',
    'verde', 'vermelho/vermelha', 'roxo/roxa', 'amarelo/amarela', 'brilhante', 'radiante', 'pintado/pintada',
    'raro/rara', 'real', 'livre', 'vivo/viva', 'feroz', 'agil', 'danado/danada', 'sapeca', 'levado/levada',
    'sonolento/sonolenta', 'faminto/faminta', 'guloso/gulosa', 'sereno/serena', 'veterano/veterana', 'novato/novata',
    'curioso/curiosa', 'teimoso/teimosa', 'sonhador/sonhadora', 'viajante', 'festeiro/festeira',
    'dancarino/dancarina', 'cantor/cantora', 'artilheiro/artilheira', 'goleiro/goleira', 'campeao/campea', 'tropical',
    'imortal', 'supremo/suprema', 'ninja', 'samurai', 'pirata', 'viking', 'astronauta', 'cientista', 'poeta',
    'rockeiro/rockeira', 'sambista', 'forrozeiro/forrozeira', 'funkeiro/funkeira', 'pagodeiro/pagodeira',
    'sertanejo/sertaneja', 'surfista', 'skatista', 'gamer', 'nerd', 'geek',
  ].map(adj),
  foods: [
    ...['acai', 'pastel', 'brigadeiro', 'guarana', 'churrasco', 'cuscuz', 'quindim', 'sorvete', 'beijinho', 'acaraje',
      'jilo', 'caju', 'cupuacu', 'maracuja', 'cafezinho', 'bolinho', 'churros', 'chiclete', 'biscoito', 'suco', 'pudim'].map(m),
    ...['tapioca', 'feijoada', 'mandioca', 'farofa', 'picanha', 'pipoca', 'goiabada', 'pacoca', 'cocada', 'moqueca', 'manga',
      'jabuticaba', 'melancia', 'canjica', 'pizza', 'esfiha', 'rapadura', 'bolacha'].map(f),
  ],
  foodAdjectives: [
    'gelado/gelada', 'quentinho/quentinha', 'crocante', 'cremoso/cremosa', 'fresquinho/fresquinha', 'doce',
    'faminto/faminta', 'feliz', 'sortudo/sortuda', 'top', 'massa', 'dahora', 'brabo/braba', 'chique', 'tropical',
    'dourado/dourada', 'premiado/premiada',
  ].map(adj),
  titles: {
    any: ['tio', 'tia', 'ze', 'mc', 'vovo', 'xerife'],
    m: ['seu', 'doutor', 'professor'],
    f: ['dona', 'doutora', 'professora'],
  },
  persons: [m('guri'), f('guria'), m('moleque'), m('mano'), m('caipira'), m('sertanejo'), f('sertaneja')],
  t5Titles: {
    m: ['rei', 'patrao', 'chefe', 'mestre', 'dono', 'craque', 'fera', 'cria', 'tio', 'mc', 'principe', 'xerife'],
    f: ['rainha', 'patroa', 'mestra', 'dona', 'princesa', 'tia'],
  },
  t5Article: { m: 'do', f: 'da' },
  t5Things: {
    m: ['samba', 'forro', 'pagode', 'funk', 'sertanejo', 'axe', 'frevo', 'carnaval', 'sertao', 'mar', 'sol', 'cerrado',
      'pantanal', 'gol', 'trevo', 'pastel', 'acai', 'churrasco', 'guarana', 'bloco', 'vento', 'rio', 'litoral', 'interior',
      'norte', 'sul', 'nordeste', 'baile', 'campo', 'luau', 'verao', 'domingo', 'camarote'],
    f: ['praia', 'lua', 'amazonia', 'bola', 'sorte', 'farofa', 'feijoada', 'quadra', 'folia', 'festa', 'roda', 'capoeira',
      'ginga', 'pipa', 'peteca', 'brisa', 'chuva', 'estrela', 'mata', 'bahia', 'rua', 'pista', 'lapa', 'serra', 'lagoa',
      'cachoeira', 'cocada'],
  },
  idioms: ['cabra.da.peste', 'craque.da.bola', 'dono.da.bola', 'fera.da.bola', 'rei.da.cocada', 'rainha.da.folia',
    'rei.do.camarote', 'cria.do.rio', 'cria.da.bahia', 'principe.do.forro'],
  regionals: [
    'carioca', 'paulista', 'paulistano/paulistana', 'fluminense', 'mineiro/mineira', 'baiano/baiana', 'gaucho/gaucha',
    'nordestino/nordestina', 'cearense', 'pernambucano/pernambucana', 'capixaba', 'catarinense', 'paranaense',
    'goiano/goiana', 'manauara', 'paraense', 'potiguar', 'sergipano/sergipana', 'alagoano/alagoana', 'maranhense',
    'piauiense', 'brasiliense', 'amazonense', 'curitibano/curitibana', 'brasileiro/brasileira', 'tupiniquim', 'caipira',
    'praiano/praiana', 'interiorano/interiorana', 'acreano/acreana', 'matogrossense',
  ].map(adj),
  excluded: [
    // politics
    'lula', 'mito', 'capitao', 'gado', 'coxinha', 'mortadela', 'petista', 'bolsonaro', 'isentao',
    // slurs / sexual double meanings
    'veado', 'vaca', 'galinha', 'piranha', 'cachorro', 'cachorra', 'porco', 'porca', 'burro', 'burra', 'anta', 'macaco',
    'jumento', 'mula', 'egua', 'pinto', 'peru', 'periquita', 'picapau', 'rola', 'pau', 'rabo', 'quente', 'gostoso',
    'gostosa', 'safado', 'safada', 'sexy', 'delicia', 'tigresa', 'pato', 'baleia',
    // alcohol / gambling
    'caipirinha', 'cerveja', 'cachaca', 'breja', 'bicho', 'bicheiro', 'aposta',
    // promises of winning
    'milionario', 'ganhador', 'vencedor', 'rico',
    // odd legacy words
    'rato', 'mico', 'jagua', 'ouro', 'rubi', 'jade', 'opala', 'mago', 'magia', 'lirio',
  ],
};
